module.exports = __webpack_public_path__ + "static/media/Organization_1.571bae80.svg";